
export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE';
export const UPDATE_USER_NAME = 'UPDATE_USER_NAME';
export const UPDATE_USER_FULLED = 'UPDATE_USER_FULLED';
export const UPDATE_USER_IS_LOGIN = 'UPDATE_USER_IS_LOGIN';
export const UPDATE_SHOW_SETTING = 'UPDATE_SHOW_SETTING';
export const UPDATE_USER_PROJECT_COUNT = 'UPDATE_USER_PROJECT_COUNT';
export const UPDATE_IS_SHOW_COMMONG_MOUDLE = 'UPDATE_IS_SHOW_COMMONG_MOUDLE';
export const UPDATE_PRIVACY_POLICY_URL = 'UPDATE_PRIVACY_POLICY_URL';
export const UPDATE_PRIMIOR_LINK_URL = 'UPDATE_PRIMIOR_LINK_URL';
export const UPDATE_TERMSOF_SERVICE = 'UPDATE_TERMSOF_SERVICE';
export const UPDATE_PRIMIOR_RATING_PDF = 'UPDATE_PRIMIOR_RATING_PDF';